/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.url.signer.rpc.UrlSignerRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './UrlSignerRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.url.signer.rpc.UrlSignerRpc#signUrl
 */
export const SIGN_URL_MUTATION_FIELD_NAME = 'com_hubspot_url_signer_rpc_UrlSignerRpc_signUrl';
export const SIGN_URL_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SIGN_URL_MUTATION_FIELD_NAME,
  args: ['unsignedUrl', 'entity', 'httpMethod'],
  fetcher(request, ctx) {
    return chirpClient.call(References.signUrlRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.url.signer.rpc.UrlSignerRpc#signUrlForForm
 */
export const SIGN_URL_FOR_FORM_MUTATION_FIELD_NAME = 'com_hubspot_url_signer_rpc_UrlSignerRpc_signUrlForForm';
export const SIGN_URL_FOR_FORM_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SIGN_URL_FOR_FORM_MUTATION_FIELD_NAME,
  args: ['formData', 'unsignedUrl', 'httpMethod'],
  fetcher(request, ctx) {
    return chirpClient.call(References.signUrlForFormRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});